import React from 'react';
import styles from './styles.module.css';

export const Text: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p className={styles.mainModalText}>{children}</p>
);
